import { render, staticRenderFns } from "./UgcSales.vue?vue&type=template&id=76e3460c&scoped=true&"
import script from "./UgcSales.vue?vue&type=script&lang=js&"
export * from "./UgcSales.vue?vue&type=script&lang=js&"
import style0 from "./UgcSales.vue?vue&type=style&index=0&id=76e3460c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3460c",
  null
  
)

export default component.exports